<template>
  <div>
    <x-tabula
      ref="table"
      rowKey="goodsId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_img" slot-scope="{row}">
        <div style="width:'100px'">
          <img style="max-height: 50px;width: 100px;object-fit: cover;" :src="row.img" alt="">
        </div>
      </template>

      <template slot="opt_type" slot-scope="{row}">
        {{getTypeDesc(row.type)}}
      </template>
      <template slot="opt_price" slot-scope="{row}">
        ￥{{row.price}}
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.status]"></span>
          <span>{{ getStatusDesc(row.status) }}</span>
        </div>
      </template>

      <template slot="opt_saleStatus" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.saleStatus]"></span>
          <span>{{ getSaleStatusDesc(row.saleStatus) }}</span>
        </div>
      </template>
      <template slot="opt_t" slot-scope="{row}">
        <a-tooltip :title="row.title">
          <div class="feed-over-text">{{row.title}}</div>
        </a-tooltip>
      </template>
      <template slot="opt_s" slot-scope="{row}">
        <a-tooltip :title="row.shopName">
          <div class="feed-over-text">{{row.shopName}}</div>
        </a-tooltip>
      </template>
      <template slot="opt_y" slot-scope="{row}">
        <a-tooltip :title="row.expireDesc">
          <div class="feed-over-text">{{row.expireDesc}}</div>
        </a-tooltip>
      </template>

    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'goods',
  data () {
    return {
      activityColor: [
        'info-bg',
        'success-bg'
      ],
      dataSource: [],
      searchList: [
        {props: ['title'], placeholder: '标题', inputType: 'input'},
        {props: ['type'], placeholder: '类型', options: [], inputType: 'select'},
        {props: ['shopId'], placeholder: '店铺', options: [], inputType: 'select'},
        {props: ['price'], placeholder: '价格', options: [], inputType: 'input'},
        {props: ['status'], placeholder: '上架状态', options: [], inputType: 'select'},
        {props: ['saleStatus'], placeholder: '有效状态', options: [], inputType: 'select'}
      ],
      columns: [
        {title: 'ID', dataIndex: 'goodsId', align: '', width: ''},
        {title: '封面图', dataIndex: 'mobilePhone', align: '', width: '', scopedSlots: { customRender: 'img' }},
        {title: '标题', dataIndex: 'title', align: '', width: '', scopedSlots: {customRender: 't'}},
        {title: '类型', dataIndex: 'type', align: '', width: '', scopedSlots: { customRender: 'type' }},
        {title: '店铺', dataIndex: 'shopName', align: '', width: '', scopedSlots: {customRender: 's'}},
        {title: '有效期', dataIndex: 'expireDesc', align: '', width: '', scopedSlots: {customRender: 'y'}},
        {title: '价格', dataIndex: 'price', align: '', width: '', scopedSlots: { customRender: 'price' }},
        {title: '状态', dataIndex: 'status', align: '', width: '120px', scopedSlots: { customRender: 'status' }},
        {title: '有效状态', dataIndex: 'saleStatus', align: '', width: '120px', scopedSlots: { customRender: 'saleStatus' }},
        { title: '操作', dataIndex: 'action', align: 'left', width: '250', scopedSlots: {customRender: 'action'} }
      ],
      tableOptList: [],
      rowOptList: [
        {
          text: '详情',
          handle: (row) => this.toDetail(row.goodsId, row.type),
          permi: ['community:localGoods:detail']
        },
        {
          text: '查看订单',
          handle: (row) => this.toOrderList(row.goodsId),
          permi: ['community:localOrder:detail']
        }
      ],
      searchParams: {
        title: undefined,
        type: undefined,
        shopId: undefined,
        // 0已下架 1上架
        status: undefined,
        // 0已过期 1销售中
        saleStatus: undefined,
        // 价格
        price: undefined
      },
      listApi: {
        url: '/local/goods/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {}
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      // 获取类型下拉
      this.$get({
        url: '/dict/data/dictType/comu_local_good_type',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data;
      });
      // 获取上下架状态
      this.$get({
        url: '/dict/data/dictType/comu_local_offShelf_status',
        params: {}
      }).then(({data}) => {
        this.searchList[4].options = data;
      });
      // 获取有效状态
      this.$get({
        url: '/dict/data/dictType/comu_local_sale_status',
        params: {}
      }).then(({data}) => {
        this.searchList[5].options = data;
      });

      // 获取店铺下拉接口
      this.$get({
        url: '/local/leader/shopTreeSelect',
        params: {}
      }).then(({data}) => {
        this.searchList[2].options = data;
      });
    },
    getTypeDesc (type) {
      for (let i = 0; i < this.searchList[1].options.length; i++) {
        if (this.searchList[1].options[i].value === type + '') {
          return this.searchList[1].options[i].label;
        }
      }
      return '';
    },
    getStatusDesc (type) {
      for (let i = 0; i < this.searchList[4].options.length; i++) {
        if (this.searchList[4].options[i].value === type + '') {
          return this.searchList[4].options[i].label;
        }
      }
      return '';
    },
    getSaleStatusDesc (type) {
      for (let i = 0; i < this.searchList[5].options.length; i++) {
        if (this.searchList[5].options[i].value === type + '') {
          return this.searchList[5].options[i].label;
        }
      }
      return '';
    },
    toDetail (id, type) {
      this.$router.push({
        name: 'goodsDetail',
        query: { id: id, type, ...this.breadParam(this) }
      });
    },
    toOrderList (id) {
      this.$router.push({
        name: 'goodsOrder',
        query: { goodsId: id, ...this.breadParam(this) }
      });
    }
  }
};
</script>

<style scoped>

</style>
